import '../../styles/layouts/legacy-viewer.scss';
import { SAVED_WORK_PATH, V4_ENTRY_PATH } from '../constants/legacy-viewer';
import { Link } from 'react-router-dom';
import PageLoadingIndicator from '../components/loading-indicators/page';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useUserContext from '../hooks/context/use-user-context';

export default function LegacyViewerLayout({ children }) {
  const { activeStudent, students = [] } = useUserContext();
  const { t, ready } = useTranslation('legacy-viewer');
  if (!ready) return null;

  return (
    <div className="legacy-viewer">
      <header className="legacy-viewer__header">
        <Link to={SAVED_WORK_PATH}>{t('title')}</Link>
        <nav aria-label={t('navigation')}>
          {activeStudent && <span>{activeStudent.firstName}</span>}
          {students.length > 1 && <Link to="/select-profile">{t('switchStudent')}</Link>}
          <a href={V4_ENTRY_PATH}>{t('openV4')}</a>
        </nav>
      </header>
      <main className="main-content main-content--chromeless" id="main-content">
        {children}
      </main>
      <PageLoadingIndicator />
    </div>
  );
}
